// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d639c004","977":"279b6d75"}[chunkId] + ".chunk.js";
};